module.exports = __webpack_public_path__ + "static/media/checkedBox.d8b8b631.svg";